var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container LegalFileDetail" },
    [
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("settlementUnit.ConfidentialityAgreementApply"),
                name: "1",
              },
            },
            [
              _c(
                "div",
                { staticClass: "searchBox_top" },
                [
                  _vm.LegalFileDetailForm.status == "draft" ||
                  _vm.LegalFileDetailForm.status == "appr_rej"
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SaveLawFile,
                              expression: "SaveLawFile",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.save },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.saveDraft")) + " ")]
                      )
                    : _vm._e(),
                  _vm.LegalFileDetailForm.status == "draft" ||
                  _vm.LegalFileDetailForm.status == "appr_rej"
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.SubmitLawFile,
                              expression: "SubmitLawFile",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: { click: _vm.submit },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.submit")) + " ")]
                      )
                    : _vm._e(),
                  _vm.LegalFileDetailForm.canAudit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.CompleteLawFile,
                              expression: "CompleteLawFile",
                            },
                          ],
                          key: "CompleteLawFile",
                          attrs: { type: "primary" },
                          on: { click: _vm.goComplete },
                        },
                        [_vm._v("审批")]
                      )
                    : _vm._e(),
                  [
                    _vm.LegalFileDetailForm.status == "appr_pass" && _vm.checked
                      ? _c(
                          "el-upload",
                          {
                            ref: "upload",
                            staticStyle: {
                              float: "left",
                              "padding-right": "10px",
                            },
                            attrs: {
                              action: "upload",
                              "http-request": _vm.uploadConfirmSign,
                              "show-file-list": false,
                              name: "file",
                            },
                          },
                          [
                            _vm.LegalFileDetailForm.status == "appr_pass"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { slot: "trigger", type: "primary" },
                                    slot: "trigger",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("settlementUnit.appr_pass")
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.LegalFileDetailForm.status == "appr_pass" &&
                    !_vm.checked
                      ? _c(
                          "el-button",
                          {
                            attrs: { slot: "trigger", type: "primary" },
                            on: { click: _vm.beforeUpload },
                            slot: "trigger",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("settlementUnit.appr_pass")) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.historyBack },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.close")))]
                  ),
                ],
                2
              ),
              _c(
                "el-form",
                {
                  ref: "LegalFileDetailForm",
                  attrs: {
                    model: _vm.LegalFileDetailForm,
                    rules: _vm.rules,
                    "label-width": "180px",
                  },
                },
                [
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("settlementUnit.baseInfo"))),
                          ]),
                        ]
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("settlementUnit.formType"),
                                    prop: "formType",
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.formTypeDisabled ||
                                          _vm.LegalFileDetailForm.status ==
                                            "appr_ss" ||
                                          _vm.LegalFileDetailForm.status ==
                                            "appr_lp" ||
                                          _vm.LegalFileDetailForm.status ==
                                            "appr_pass" ||
                                          _vm.LegalFileDetailForm.status ==
                                            "pigeonhole",
                                      },
                                      on: { change: _vm.formTypeChange },
                                      model: {
                                        value: _vm.LegalFileDetailForm.formType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.LegalFileDetailForm,
                                            "formType",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "LegalFileDetailForm.formType",
                                      },
                                    },
                                    _vm._l(
                                      _vm.formTypeList,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label:
                                              _vm._f("inputChoiceI18n")(item),
                                            value: item.code,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("settlementUnit.applyDate"),
                                    prop: "applyDate",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    attrs: {
                                      "value-format": "yyyy-MM-dd",
                                      type: "date",
                                      disabled: "",
                                      placeholder: _vm.$t("common.selDate"),
                                    },
                                    model: {
                                      value: _vm.LegalFileDetailForm.applyDate,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "applyDate",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.applyDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 22 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("settlementUnit.title"),
                                    prop: "theTitle",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      disabled:
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_ss" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_lp" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_pass" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "pigeonhole",
                                    },
                                    model: {
                                      value: _vm.LegalFileDetailForm.theTitle,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "theTitle",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.theTitle",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("settlementUnit.agent"),
                                    prop: "agent",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled: "",
                                      placeholder: _vm.$t(
                                        "material.DisplayAfterSave"
                                      ),
                                    },
                                    model: {
                                      value: _vm.LegalFileDetailForm.agent,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "agent",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "LegalFileDetailForm.agent",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.agentDepartment"
                                    ),
                                    prop: "agentDepartment",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value:
                                        _vm.LegalFileDetailForm.agentDepartment,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "agentDepartment",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.agentDepartment",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.Protocoltype"
                                    ),
                                    prop: "protocolType",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    attrs: {
                                      clearable: "",
                                      table: "TM_LAW_FILE",
                                      field: "PROTOCOL_TYPE",
                                      disabled:
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_ss" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_lp" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_pass" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "pigeonhole",
                                    },
                                    model: {
                                      value:
                                        _vm.LegalFileDetailForm.protocolType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "protocolType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.protocolType",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.isMCDTemplate"
                                    ),
                                    prop: "useMdTemplate",
                                  },
                                },
                                [
                                  _vm.LegalFileDetailForm.formType == 3
                                    ? _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_LAW_FILE",
                                          field: "Y_N",
                                          disabled: "",
                                        },
                                        model: {
                                          value:
                                            _vm.LegalFileDetailForm
                                              .useMdTemplate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.LegalFileDetailForm,
                                              "useMdTemplate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "LegalFileDetailForm.useMdTemplate",
                                        },
                                      })
                                    : _c("ic-select", {
                                        attrs: {
                                          clearable: "",
                                          table: "TM_LAW_FILE",
                                          field: "Y_N",
                                          disabled:
                                            _vm.LegalFileDetailForm.status ==
                                              "appr_ss" ||
                                            _vm.LegalFileDetailForm.status ==
                                              "appr_lp" ||
                                            _vm.LegalFileDetailForm.status ==
                                              "appr_pass" ||
                                            _vm.LegalFileDetailForm.status ==
                                              "pigeonhole",
                                        },
                                        model: {
                                          value:
                                            _vm.LegalFileDetailForm
                                              .useMdTemplate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.LegalFileDetailForm,
                                              "useMdTemplate",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "LegalFileDetailForm.useMdTemplate",
                                        },
                                      }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.ContractName"
                                    ),
                                    prop: "contractName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      disabled:
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_ss" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_lp" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_pass" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "pigeonhole",
                                    },
                                    model: {
                                      value:
                                        _vm.LegalFileDetailForm.contractName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "contractName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.contractName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("settlementUnit.ContractNo"),
                                    prop: "contractNo",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: { disabled: "" },
                                    model: {
                                      value: _vm.LegalFileDetailForm.contractNo,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "contractNo",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.contractNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("settlementUnit.ContractingParties")
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.OurPrincipalName"
                                    ),
                                    prop: "subjectName",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    attrs: {
                                      table: "TM_LAW_FILE",
                                      field: "SUBJECT_NAME",
                                      disabled:
                                        _vm.LegalFileDetailForm.formType !=
                                          "" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_ss" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_lp" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_pass" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "pigeonhole",
                                    },
                                    model: {
                                      value:
                                        _vm.LegalFileDetailForm.subjectName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "subjectName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.subjectName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.supplierMainName"
                                    ),
                                    prop: "supplierName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      disabled:
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_ss" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_lp" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_pass" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "pigeonhole",
                                    },
                                    model: {
                                      value:
                                        _vm.LegalFileDetailForm.supplierName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "supplierName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.supplierName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("settlementUnit.ContractOverview"))
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.contractValidity"
                                    ),
                                    prop: "termOfContract",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    attrs: {
                                      clearable: "",
                                      table: "TM_LAW_FILE",
                                      field: "TERM_OF_CONTRACT",
                                      disabled:
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_ss" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_lp" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_pass" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "pigeonhole",
                                    },
                                    model: {
                                      value:
                                        _vm.LegalFileDetailForm.termOfContract,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "termOfContract",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.termOfContract",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.isAutoRenewal"
                                    ),
                                    prop: "isAutomaticRenewal",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    attrs: {
                                      clearable: "",
                                      table: "TM_LAW_FILE",
                                      field: "Y_N",
                                      disabled: "",
                                    },
                                    model: {
                                      value:
                                        _vm.LegalFileDetailForm
                                          .isAutomaticRenewal,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "isAutomaticRenewal",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.isAutomaticRenewal",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.AutoRenewalCondition"
                                    ),
                                    prop: "automaticRenewalConditions",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    attrs: {
                                      clearable: "",
                                      table: "TM_LAW_FILE",
                                      field: "AUTOMATIC_RENEWAL_CONDITIONS",
                                      disabled:
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_ss" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_lp" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "appr_pass" ||
                                        _vm.LegalFileDetailForm.status ==
                                          "pigeonhole",
                                    },
                                    model: {
                                      value:
                                        _vm.LegalFileDetailForm
                                          .automaticRenewalConditions,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "automaticRenewalConditions",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.automaticRenewalConditions",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 11 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "settlementUnit.amountAndType"
                                    ),
                                    prop: "amountType",
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    attrs: {
                                      clearable: "",
                                      table: "TM_LAW_FILE",
                                      field: "AMOUNT_TYPE",
                                      disabled: "",
                                    },
                                    model: {
                                      value: _vm.LegalFileDetailForm.amountType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.LegalFileDetailForm,
                                          "amountType",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "LegalFileDetailForm.amountType",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-card",
                    { staticClass: "box-card" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("settlementUnit.downloadTemplate"))
                            ),
                          ]),
                          _vm.LegalFileDetailForm.formType == 0
                            ? _c(
                                "el-link",
                                {
                                  staticStyle: { "margin-left": "20px" },
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.downloadTemplate(
                                        "/templates/download/附件二 麦当劳保密协议_CN.PDF",
                                        "附件二 麦当劳保密协议_CN.PDF"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("附件二 麦当劳保密协议_CN.PDF")]
                              )
                            : _vm._e(),
                          _vm.LegalFileDetailForm.formType == 1
                            ? _c(
                                "el-link",
                                {
                                  staticStyle: { "margin-left": "20px" },
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.downloadTemplate(
                                        "/templates/download/采购协议延伸库存.pdf",
                                        "采购协议延伸库存.pdf"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("采购协议延伸库存.pdf")]
                              )
                            : _vm._e(),
                          _vm.LegalFileDetailForm.formType == 2
                            ? _c(
                                "el-link",
                                {
                                  staticStyle: { "margin-left": "20px" },
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.downloadTemplate(
                                        "/templates/download/采购协议非延伸库存.pdf",
                                        "采购协议非延伸库存.pdf"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("采购协议非延伸库存.pdf")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.LegalFileDetailForm.useMdTemplate == 1,
                              expression:
                                "LegalFileDetailForm.useMdTemplate==1",
                            },
                          ],
                        },
                        [
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v(
                              _vm._s(_vm.$t("settlementUnit.ContractVersion"))
                            ),
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 20 } },
                            [
                              !(
                                _vm.LegalFileDetailForm.formType == 0 &&
                                _vm.LegalFileDetailForm.useMdTemplate == 0
                              )
                                ? _c(
                                    "el-form-item",
                                    {
                                      staticStyle: { "margin-bottom": "0px" },
                                      attrs: {
                                        "label-width": "0",
                                        prop: "tmLawFileId",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-upload",
                                        {
                                          ref: "upload",
                                          staticStyle: { float: "left" },
                                          attrs: {
                                            action: "upload",
                                            "http-request": _vm.uploadConfirm,
                                            "show-file-list": false,
                                            multiple: "",
                                            disabled:
                                              _vm.LegalFileDetailForm.status ==
                                                "appr_ss" ||
                                              _vm.LegalFileDetailForm.status ==
                                                "appr_lp" ||
                                              _vm.LegalFileDetailForm.status ==
                                                "appr_pass" ||
                                              _vm.LegalFileDetailForm.status ==
                                                "pigeonhole",
                                            name: "file",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                slot: "trigger",
                                                size: "small",
                                                type: "primary",
                                              },
                                              slot: "trigger",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("common.selectFile")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        _vm._l(_vm.fileList, function (item, index) {
                          return _c(
                            "span",
                            {
                              key: index,
                              staticStyle: { "padding-right": "15px" },
                            },
                            [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.downloadFile(item)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(item.documentName))]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "20px" },
                                  attrs: { type: "primary", size: "mini" },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.deleteFile(
                                        item.tmDocumentId,
                                        index,
                                        _vm.fileList
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("common.del")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _c("div", {
                        staticStyle: {
                          "border-bottom": "1px solid #EBEEF5",
                          padding: "10px",
                        },
                      }),
                      _c(
                        "div",
                        [
                          _c("div", { staticStyle: { margin: "15px 0" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("settlementUnit.fileListWater"))
                            ),
                          ]),
                          _vm._l(_vm.fileListWater, function (item, index) {
                            return _c(
                              "span",
                              {
                                key: index,
                                staticStyle: { "padding-right": "15px" },
                              },
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.downloadFile(item)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.documentName))]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "20px" },
                                    attrs: { type: "primary", size: "mini" },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.deleteFile(
                                          item.tmDocumentId,
                                          index,
                                          _vm.fileList
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("common.del")) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                      _c("div", {
                        staticStyle: {
                          "border-bottom": "1px solid #EBEEF5",
                          padding: "10px",
                        },
                      }),
                      _c(
                        "el-row",
                        { staticStyle: { margin: "15px 0" } },
                        [
                          _c("el-col", { attrs: { span: 3 } }, [
                            _vm._v(_vm._s(_vm.$t("settlementUnit.appr_pass"))),
                          ]),
                        ],
                        1
                      ),
                      _vm.LegalFileDetailForm.status == "appr_pass"
                        ? _c(
                            "el-row",
                            { staticStyle: { margin: "15px 0" } },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  model: {
                                    value: _vm.checked,
                                    callback: function ($$v) {
                                      _vm.checked = $$v
                                    },
                                    expression: "checked",
                                  },
                                },
                                [
                                  _vm._v(
                                    " 供应商兹确认，本上传合同已经双方充分协商和沟通，供应商已充分理解并知悉合同的全部内容，且上传的签署版本与供应商下载的水印版内容完全一致。 "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        [
                          _c("span", {
                            staticStyle: { "padding-right": "35px" },
                          }),
                          _vm._l(_vm.fileListSign, function (item, index) {
                            return _c(
                              "span",
                              {
                                key: index,
                                staticStyle: { "padding-right": "15px" },
                              },
                              [
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.downloadFile(item)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.documentName))]
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("common.approvalLog"), name: "4" } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.auditLog,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "createDate",
                      label: _vm.$t("common.OperationTime"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormatFilter")(
                                  scope.row.createDate,
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              ) + " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "operatorName",
                      label: _vm.$t("common.OperatorName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "action",
                      label: _vm.$t("common.PedagogicalOperation"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "comments",
                      label: _vm.$t("common.opinion"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("supplierManage.approvalWindow"),
            visible: _vm.showApproval,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showApproval = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { staticClass: "form_border", attrs: { "label-width": "120px" } },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-around" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 20 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("storeFeedback.auditor") } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.username,
                              callback: function ($$v) {
                                _vm.username = $$v
                              },
                              expression: "username",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("common.approvalTime") } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.date,
                              callback: function ($$v) {
                                _vm.date = $$v
                              },
                              expression: "date",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.approvalResults"),
                            prop: "status",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "1" },
                              model: {
                                value: _vm.status,
                                callback: function ($$v) {
                                  _vm.status = $$v
                                },
                                expression: "status",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.pass")))]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: "2" },
                              model: {
                                value: _vm.status,
                                callback: function ($$v) {
                                  _vm.status = $$v
                                },
                                expression: "status",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.noPass")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("common.approvalRemarks"),
                            prop: "remark",
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            attrs: { type: "textarea" },
                            model: {
                              value: _vm.remark,
                              callback: function ($$v) {
                                _vm.remark = $$v
                              },
                              expression: "remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer", align: "center" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.complete } },
                [_vm._v(_vm._s(_vm.$t("common.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.showApproval = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }